import React, { useEffect, useRef, Fragment, useState } from 'react';
import OpenSeadragon from 'openseadragon';
import { Box, CircularProgress, css } from '@mui/material';
import queryString from 'query-string';

import { RulerTool } from '../../components/RulerTool';
import { GalleryTool } from '../../components/GaleryTool';
import { CziImageResponse } from './models/CziGetResponse';
import { useGetCziByWellId } from './api/useCziController';

const backgroundColor = '#454d62';

const containerPictureStyle = css({
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
    background: backgroundColor
});

const containerLoadingStyle = css({
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: backgroundColor
});

const containerIsLoadingPicture = css({
    position: 'absolute',
    top: 15,
    right: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

export function CziViewer() {
    const containerDomRef = useRef<HTMLDivElement>(null);
    const [openSeaDragonInstance, setOpenSeaDragonInstance] = useState<OpenSeadragon.Viewer | null>(null);
    const [imagesGallery, setImagesGallery] = useState<CziImageResponse[]>([]);

    const queryParams = queryString.parse(window.location.search);
    const wellId = typeof queryParams.wellId === 'string' ? queryParams.wellId : undefined;

    const { data, isLoading: isLoadingApi } = useGetCziByWellId(wellId);

    const [isLoadingPicture, setIsLoadingPicture] = useState(true);
    const [resetId, setResetId] = useState(0);

    const loadingPicture = (openSeaDragonInstance: OpenSeadragon.Viewer | null) => {
        console.log('star loading picture');

        if (!openSeaDragonInstance){
            return;
        }

        const tiledImage = openSeaDragonInstance.world.getItemAt(0);
        setIsLoadingPicture(true);

        if (!tiledImage){
            return;
        }

        const hideLoading = () => {
            console.log('chamando pra false');

            setIsLoadingPicture(false);
        };

        if (tiledImage.getFullyLoaded()) {
            hideLoading();
        } else {
            tiledImage.addOnceHandler('fully-loaded-change', function (event) {
                if (event.fullyLoaded) {
                    console.log('star loading picture');
                    hideLoading();
                }
            });
        }
    };

    useEffect(() => {
        if (containerDomRef.current && data && data.images) {
            // @ts-ignore
            const images = data.images.toSorted((a, b) => a.channel - b.channel);
            setImagesGallery(images);

            if (images.length > 0) {
                const mainImage = images[0];

                const instance = OpenSeadragon({
                    element: containerDomRef.current,
                    tileSources: { type: 'image', url: mainImage.url },
                    animationTime: 0,
                    blendTime: 0.1,
                    maxZoomPixelRatio: 2,
                    minZoomLevel: 0.1,
                    maxZoomLevel: 8,
                    zoomPerScroll: 2,
                    visibilityRatio: 1.0,
                    constrainDuringPan: true,
                    showNavigationControl: false,
                    gestureSettingsMouse: {
                        scrollToZoom: true,
                        clickToZoom: false,
                        dblClickToZoom: true,
                        pinchToZoom: true,
                        flickEnabled: true,
                    },
                });

                instance.addHandler('open', () => loadingPicture(instance));

                setOpenSeaDragonInstance(instance);
            }
        }
    }, [data]);

    const handleImageChanged = () => {
        loadingPicture(openSeaDragonInstance);
        setResetId(prev => prev+1);
    };

    return (
        <Fragment>
            {isLoadingApi ? <Box css={containerLoadingStyle}><CircularProgress size={80} /></Box> :
                <Fragment>
                    <Box
                        css={containerPictureStyle}
                        ref={containerDomRef}
                    >
                    </Box>
                    {isLoadingPicture && <Box css={containerIsLoadingPicture}><CircularProgress size={40} /></Box>}
                    <RulerTool key={resetId} viewer={openSeaDragonInstance} pixelsPerUnit={348.2} unitValue=' mm' />
                    <GalleryTool viewer={openSeaDragonInstance}
                        onImageChanged={handleImageChanged}
                        images={imagesGallery.map(x => ({
                            url: x.url,
                            title: x.title
                        }))} />
                </Fragment>}
        </Fragment>
    );
}